import { Component, Input, EventEmitter, Output, OnChanges, SimpleChanges, input, output } from "@angular/core";
import { NgxPaginationModule, PaginationInstance } from "ngx-pagination";

import { PageDto } from "gast-common-ng2";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "portal-generic-pagination",
  templateUrl: "./generic-pagination.component.html",
  styleUrls: ["./generic-pagination.component.scss"],
  standalone: true,
  imports: [TranslatePipe, NgxPaginationModule],
})
export class GenericPaginationComponent implements OnChanges {
  readonly pageDto = input<PageDto<unknown>>();
  readonly colorCode = input<string>("");
  // Two way binding
  @Input() config!: PaginationInstance;
  @Output() configChange = new EventEmitter<PaginationInstance>();

  readonly pageChange = output<number>();
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["pageDto"] &&
      changes["pageDto"].currentValue &&
      this.hasChanged(changes["pageDto"].currentValue, changes["pageDto"].previousValue)
    ) {
      this.#mapConfig(this.pageDto() as PageDto<unknown>);
    }
  }

  hasChanged(current: PageDto<unknown>, previous: PageDto<unknown>): boolean {
    if (current && !previous) {
      return true;
    }
    return (
      current.size !== previous.size ||
      current.number !== previous.number ||
      current.totalElements !== previous.totalElements
    );
  }

  onPageChange(page: number): void {
    const pageToSearch = page > 0 ? page - 1 : page; // pages on backend are indexed starting with '0'
    this.pageChange.emit(pageToSearch);

    this.config.currentPage = page;
    this.configChange.emit(this.config);
  }

  #mapConfig(pageDto: PageDto<unknown>): void {
    this.config.itemsPerPage = pageDto.size;
    this.config.currentPage = ++pageDto.number; // pages on backend are indexed starting with '0'
    this.config.totalItems = pageDto.totalElements;

    this.configChange.emit(this.config);
  }
}
